<template>
    <div class="dropdown-menu">
        <button type="button" class="dropdown-menu__btn" @click="toggleDropdown">
            <slot name="button">
                <icon-x-dots />
            </slot>
        </button>

        <div
            :class="['dropdown-menu__popout', {
                'is-active': showDropdown
            }]">
            <div class="dropdown-menu__overlay" @click="toggleDropdown" />

            <div class="dropdown-menu__content">
                <slot name="content" />
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue'
import IconXDots from '@/components/icons/icon-x-dots/icon-x-dots';

export default {
    name: 'Dropdown',

    components: {
        IconXDots
    },

    setup() {
        const showDropdown = ref(false);

        const toggleDropdown = () => {
            showDropdown.value = !showDropdown.value
        }

        return {
            showDropdown,
            toggleDropdown
        }
    }
}
</script>

<style>

</style>
